import styled from 'styled-components';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import { color } from '@nuvolo/nuux-theme/utils';

export const WarningLabel = styled(NuvoLabel)`
  color: ${color('primary', 'dark')};
  background-color: ${color('warn', 'middle', 0.15)};
  border: 1px solid ${color('warn', 'middle')} !important;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  position: absolute;
  margin-right: 250px;
`;

export const InfoLabel = styled(NuvoLabel)`
  color: ${color('primary', 'dark')};
  background-color: ${color('info', 'middle', 0.15)};
  border: 1px solid ${color('info', 'middle')} !important;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  width: 100%;
`;

export const PreviewWarningLabel = styled(NuvoLabel)`
  color: ${color('primary', 'dark')};
  background-color: ${color('warn', 'middle', 0.15)};
  border: 1px solid ${color('warn', 'middle')} !important;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  width: 100%;
  margin-top: 8px;
`;

export const DataGridWrapper = styled.div`
  margin-bottom: 16px;
`;
